import { MouseEventHandler } from 'react'
import { FormatGridType, ResourceType } from '../../types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@mui/material'

interface ResourceItemProps {
    item: ResourceType,
    onClick?: MouseEventHandler<HTMLDivElement>,
    isTarget: boolean,
    format: FormatGridType
}

export default function ResourceItem({ item, isTarget, format, onClick }: ResourceItemProps) {
    return (
        <div className={`resource-item ${isTarget ? 'active' : ''}`} onClick={onClick}>
            <div className="resource-img-wrapper">
                <FontAwesomeIcon icon='scroll' className='resource-img-icon' />
            </div>
            <div className="resource-title" title={item.label}>
                <Typography variant={'body1'} sx={format === 'list' ? {} : { fontSize: '0.8rem', lineHeight: '1' }}>
                    {item.label}
                </Typography>
                <Typography variant='caption' className='resource-title-desc'>
                    <span>{item.description}</span>
                </Typography>
            </div>
            <div className="resource-description">
                <Typography variant='caption'>
                    {item.updatedAt}
                </Typography>
            </div>
        </div>
    )
}
